var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { pxToRem } from '../../utils';
var radioStyles = {
    root: function (_a) {
        var props = _a.props;
        return (__assign({ outline: 0 }, (!props.vertical && {
            display: 'inline-block',
        })));
    },
    label: function (_a) {
        var props = _a.props, variables = _a.variables;
        return (__assign({ cursor: 'pointer', display: 'inline-flex', alignItems: 'baseline', fontWeight: variables.fontWeight, minHeight: '2.5rem', backgroundColor: 'transparent' }, (props.disabled && {
            color: variables.disabledColor,
        })));
    },
    icon: function (_a) {
        var props = _a.props, variables = _a.variables;
        return (__assign({}, (props.isFromKeyboard && {
            // this creates both inset and outset box shadow that some readers (NVDA) show when radio is not checked but it is focused
            boxShadow: "0 0 0 " + pxToRem(1) + " " + variables.icon.outlineColor + "," +
                ("0 0 0 " + pxToRem(2) + " " + variables.icon.outlineColor + " inset"),
        })));
    },
};
export default radioStyles;
